import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Section from '../../../components/Section';
import { Checkbox, Header } from 'semantic-ui-react';
class SystemToggles extends Component {
    constructor(props) {
        super(props);
        this.checkChanged = this.checkChanged.bind(this);
    }
    componentDidMount(){
        const {actions} = this.props;
        actions.adminGetSystemToggles();
    }
    checkChanged(e, { name, checked }) {
        const {actions, admin} = this.props;
        const {systemToggles} = admin;
        actions.adminUpdateSystemToggles({...systemToggles, ...{[name]: checked}});
    }
    render() {
        const {systemToggles} = this.props.admin;    
        return (
            <Section name="toggles" title="System Toggles" color="red" mobileShow={this.props.mobileShow}>
                <Header as="h4" content="These settings are saved automatically" />
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <Checkbox name="canMakePayments" label="Can Make Payments?" toggle checked={systemToggles.canMakePayments} onChange={this.checkChanged} style={{marginBottom: 10}} />
                    <Checkbox name="electronicAlertsEnabled" label="Electronic Alerts Enabled?" toggle checked={systemToggles.electronicAlertsEnabled} onChange={this.checkChanged} style={{ marginBottom: 10 }}/>
                    <Checkbox name="cccClaimsEnabled" label="CCC Claims Enabled?" toggle checked={systemToggles.cccClaimsEnabled} onChange={this.checkChanged} />
                </div>
            </Section>
        );
    }
}

SystemToggles.propTypes = {
    actions: PropTypes.object.isRequired,
    admin: PropTypes.object.isRequired,
    mobileShow: PropTypes.bool,
};

export default SystemToggles;